import { useEffect, useState } from 'react';
import Tooltip from './Tooltip/Tooltip';

function isEpochTime(time: number) {
	return time.toString().length === 10;
}

export default function Countdown({
	endTs,
	className,
	minWidth,
	excludePeriod,
	endedDisplay = 'Ended',
}: {
	endTs: number;
	minWidth?: number; // used to prevent the Countdown component from "jiggling" when the width changes due to numbers changing every second
	className?: string;
	endedDisplay?: string;
	excludePeriod?: {
		days?: boolean;
		hours?: boolean;
		minutes?: boolean;
		seconds?: boolean;
	};
}) {
	const endMs = isEpochTime(endTs) ? endTs * 1000 : endTs;
	const [timeLeft, setTimeLeft] = useState(endMs - Date.now());

	const days = Math.floor(timeLeft / 1000 / 60 / 60 / 24);
	const hours = Math.floor(timeLeft / 1000 / 60 / 60) % 24;
	const minutes = Math.floor(timeLeft / 1000 / 60) % 60;
	const seconds = Math.floor(timeLeft / 1000) % 60;

	useEffect(() => {
		handleSetTimeLeft();

		const interval = setInterval(() => {
			handleSetTimeLeft();
		}, 1000);

		return () => clearInterval(interval);
	}, [endMs]);

	function handleSetTimeLeft() {
		let timeDiff = endMs - Date.now();

		if (timeDiff < 0) {
			timeDiff = 0;
		}

		setTimeLeft(timeDiff);
	}

	const countdownChunk = (num: number, symbol: string) => {
		return num ? `${num}${symbol} ` : ``;
	};

	return (
		<div className={className} style={{ minWidth: minWidth }}>
			{timeLeft === 0 ? (
				endedDisplay
			) : (
				<Tooltip
					content={new Date(endMs).toLocaleString(undefined, {
						timeZoneName: 'short',
					})}
				>
					<div className="flex">
						{excludePeriod?.days ? '' : countdownChunk(days, 'd')}
						{excludePeriod?.hours ? '' : countdownChunk(hours, 'h')}
						{excludePeriod?.minutes ? '' : countdownChunk(minutes, 'm')}
						{excludePeriod?.seconds ? '' : countdownChunk(seconds, 's')}
					</div>
				</Tooltip>
			)}
		</div>
	);
}
